<template>
  <ol v-if="isOrdered">
    <li
      v-for="(answer, index) in answers"
      :key="index"
    >
      {{ getAnswerText(answer) }}
      <recursive-help-answers
        v-if="isAnswerRecursive(answer)"
        :key="answer.title"
        :answers="answer.answers"
        :isOrdered="answer.isOrdered"
        :indent="indent + 8"
      />
    </li>
  </ol>
  <ul v-else>
    <li
      v-for="(answer, index) in answers"
      :key="index"
    >
      {{ getAnswerText(answer) }}
      <recursive-help-answers
        v-if="isAnswerRecursive(answer)"
        :key="answer.title"
        :answers="answer.answers"
        :isOrdered="answer.isOrdered"
        :indent="indent + 8"
      />
    </li>
  </ul>
</template>

<script>

export default {
  name: 'RecursiveHelpAnswers',
  props: {
    answers: {
      type: Array,
      default: undefined
    },
    isOrdered: {
      type: Boolean,
      default: false
    },
    indent: {
      type: Number,
      default: 0
    }
  },
  computed: {
    indentWithPx () {
      return `${this.indent}px`
    },
    subanswerIndentWithPx () {
      return `${this.indent + 8}px`
    }
  },
  methods: {
    isAnswerRecursive (answer) {
      return typeof answer !== 'string'
    },
    getAnswerText (answer) {
      return answer.title ?? answer
    }
  }
}
</script>

<style scoped>
  h3 {
    font-size: 18px;
    font-weight: normal;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  ul, ol {
    font-size: 18px;
    font-weight: normal;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  li {
    font-size: 18px;
    font-weight: normal;
    padding-top: 4px;
    padding-bottom: 4px;
  }
</style>
